import React from 'react';
import clsx from 'clsx';
import { EditableComponent, ResponsiveGrid, getChildComponents } from '@adobe/aem-react-editable-components';
import { getWCMModeFlagValue } from '@marriott/shared/mi-helper-utils';
import { respGridUtil } from '@marriott/mi-ui-library';
import { ProtectedContainerProps } from './ProtectedContainer.types';
import { StyledContainer, StyledHeader } from './ProtectedContainer.styles';

export const ProtectedContainerComp: React.FC<ProtectedContainerProps> = props => {
  const { isAuthorMode, model, isFromStorybook } = props;
  const { contentIsEditable, userIsAdmin } = model;

  const wcmModeDisabled = getWCMModeFlagValue();
  const isInEditorMode = !!isAuthorMode && !wcmModeDisabled;

  const cqModel = respGridUtil(model);
  const cqContainerObject = respGridUtil(cqModel?.cqItems?.['container-0'] || cqModel?.[':items']?.['container-0']);
  const { cqItems, cqItemsOrder } = cqContainerObject;
  const childComponents = getChildComponents({ cqItems, cqItemsOrder });
  const pagePath = userIsAdmin ? props?.pagePath : cqModel?.pagePath;
  const itemPath = userIsAdmin ? `${props?.itemPath}/container-0` : `${cqModel?.itemPath}/container-0`;

  return (
    <div data-component-name="o-common-static-protectedcontainer">
      {isInEditorMode ? (
        <StyledContainer
          className={clsx('protected-container__header', !contentIsEditable && 'protected-container--locked')}
        >
          <StyledHeader
            className={clsx(
              userIsAdmin && 'protected-container__header',
              !contentIsEditable && 'protected-container__locked-header'
            )}
          >
            Protected Container for {userIsAdmin ? 'Admin' : 'User'} and Content is{' '}
            {contentIsEditable ? 'Editable' : 'Locked'}
          </StyledHeader>
          {isFromStorybook ? (
            <p className="text-center pt-5">Child Components renderer here in authoring mode</p>
          ) : (
            <ResponsiveGrid
              gridClassNames=""
              columnClassNames={{
                responsivegrid: '',
              }}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              pagePath={pagePath}
              itemPath={itemPath}
              config={{
                isEmpty: () => false,
                resourceType: 'mi-aem-common-spa/components/container',
              }}
              isInEditor={contentIsEditable}
            />
          )}
        </StyledContainer>
      ) : (
        <>
          {childComponents.map((ChildComponent: React.ReactNode, index: number) => (
            <React.Fragment key={index}>{ChildComponent}</React.Fragment>
          ))}
        </>
      )}
    </div>
  );
};

export const ProtectedContainer = (props: ProtectedContainerProps) => {
  const { userIsAdmin } = props.model;

  return userIsAdmin ? (
    <EditableComponent
      config={{
        emptyLabel: 'Protected Container',
        isEmpty: () => false,
        resourceType: 'mi-aem-homepage-spa/components/content/protectedcontainer',
      }}
      {...props}
    >
      <ProtectedContainerComp {...props} />
    </EditableComponent>
  ) : (
    <ProtectedContainerComp {...props} />
  );
};
